/* src/app/modules/employees/turnos/turnos.component.css */
:host {
  --tr-brand: #e3fd64;
  --tr-brand-d: #4d7a00;
  --tr-text: #1a1d23;
  --tr-muted: #6b7280;
  --tr-border: #e5e7eb;
  --tr-surface: #ffffff;
  --tr-radius: 10px;
  --tr-shadow: 0 2px 8px rgba(0,0,0,0.07);
}
.tr-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.tr-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.tr-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.tr-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(227, 253, 100, 0.12);
  flex-shrink: 0;
}
.tr-header__icon mat-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
  color: var(--cf-brand-dark);
}
.tr-header__title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: var(--tr-text);
  line-height: 1.2;
}
.tr-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--tr-muted);
}
.tr-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.tr-btn-primary {
  background-color: var(--tr-brand) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.tr-btn-primary--lg {
  height: 44px;
  font-size: 14px;
  padding: 0 20px;
}
.tr-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 64px 24px;
}
.tr-loading__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(227, 253, 100, 0.12);
}
.tr-loading__icon-wrap mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: var(--tr-brand);
}
.tr-loading__dots {
  display: flex;
  gap: 8px;
}
.tr-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--tr-brand);
  opacity: 0.3;
  animation: tr-pulse 1.2s ease-in-out infinite;
}
.tr-loading__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.tr-loading__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
.tr-loading__text {
  margin: 0;
  font-size: 14px;
  color: var(--tr-muted);
}
@keyframes tr-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.tr-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 72px 24px;
  text-align: center;
}
.tr-empty__art {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 20px;
  background: rgba(227, 253, 100, 0.1);
}
.tr-empty__art mat-icon {
  font-size: 36px;
  width: 36px;
  height: 36px;
  color: var(--tr-brand);
}
.tr-empty__title {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: var(--tr-text);
}
.tr-empty__sub {
  margin: 0;
  font-size: 13px;
  color: var(--tr-muted);
  max-width: 340px;
}
.tr-card {
  background: var(--tr-surface);
  border-radius: var(--tr-radius);
  box-shadow: var(--tr-shadow);
  border: 1px solid var(--tr-border);
  overflow: hidden;
}
.tr-table {
  width: 100%;
}
.tr-table th.mat-mdc-header-cell {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--tr-muted);
  background: #f9fafb;
  border-bottom: 1px solid var(--tr-border);
  padding: 12px 16px;
}
.tr-table td.mat-mdc-cell {
  padding: 14px 16px;
  font-size: 13.5px;
  color: var(--tr-text);
  border-bottom: 1px solid var(--tr-border);
  vertical-align: middle;
}
.tr-row:last-child td.mat-mdc-cell {
  border-bottom: none;
}
.tr-row:hover td.mat-mdc-cell {
  background: #fafafa;
}
.tr-cell-employee {
  display: flex;
  align-items: center;
  gap: 10px;
}
.tr-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(227, 253, 100, 0.15);
  color: var(--tr-brand-d);
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
  text-transform: uppercase;
}
.tr-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11.5px;
  font-weight: 600;
  background: rgba(227, 253, 100, 0.12);
  color: #a07500;
}
.tr-date {
  font-size: 13px;
  color: var(--tr-muted);
  font-variant-numeric: tabular-nums;
}
.tr-shift-name {
  font-weight: 500;
}
.tr-col-actions {
  width: 52px;
  text-align: right !important;
  padding-right: 12px !important;
}
.tr-menu-trigger {
  opacity: 0;
  transition: opacity 0.15s;
}
.tr-row:hover .tr-menu-trigger {
  opacity: 1;
}
.tr-action-danger,
.tr-action-danger mat-icon {
  color: #dc2626 !important;
}
.tr-action-danger:hover {
  background: rgba(220, 38, 38, 0.05) !important;
}
/*# sourceMappingURL=turnos.component.css.map */
